import { useQuery } from "@tanstack/react-query";

import { axios } from "@/client/libs/axios";

/**
 * Permissions effectives de l'utilisateur connecté — source unique pour le
 * filtrage de la navigation admin (moindre privilège côté UI).
 * En cas d'erreur (route absente sur un vieux backend), on rend `undefined`
 * et la sidebar reste visible : dégradation gracieuse, jamais de blocage.
 */
export const useMyPermissions = () => {
  const query = useQuery({
    queryKey: ["permissions", "me"],
    queryFn: async () => {
      const response = await axios.get<{ permissions: string[] }>("/permission/me");
      return response.data.permissions;
    },
    staleTime: 5 * 60 * 1000,
    retry: false,
  });

  return { permissions: query.data, loading: query.isPending };
};
